export const FONT_SCALE_STEPS = Object.freeze([40, 60, 80, 100, 120, 140, 180, 200, 250, 320, 400, 500]);

export const FONT_SCALE_CHANGE_TYPE = Object.freeze({
  increase: '+1',
  decrease: '-1',
});
